
import router from '@/router';
import { Toast } from 'vant';
import { defineComponent, computed, reactive, ref, watch, toRefs } from 'vue';
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
    props:{
        active:
        {
            type: Number,
            default: 0
        }
    },
    setup(props){
        const state = reactive({ active: 0 });
        
        watch(props, (nweProps, oldProps) => {
            state.active = (nweProps.active as number);
        },{immediate: true});

        const menuList =
        [
            {
                routeName: "home"
            },
            {
                routeName: "customer-notifyList"
            },
            {
                routeName: "my"
            }
        ]

        const onChange = (index)=>
        {
            if(index!== state.active)
            {
                let routeName = menuList[index].routeName;
                router.push({name: routeName})
            }
           
        }

        return{
            ...toRefs(state),
            onChange    
        }
    }
})

